import Emissions from "@hydrologiq/shared/monitoring/figures/Emissions"
import { Emissions as EmissionsType } from "@hydrologiq/gql/graphql"
import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface TotalEmissionsFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function TotalEmissionsFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("monitoring") }: TotalEmissionsFigureProps) {
  // Transform the headline data into the Emissions format expected by the component
  const emissions: EmissionsType[] = []

  // Current day emissions
  const currentEmissions: EmissionsType = {
    __typename: "Emissions",
    start: new Date().toISOString().split("T")[0],
    diesel: data?.metadata?.diesel
      ? {
        __typename: "EmissionsReport",
        total: data?.metadata?.diesel?.total ?? 0,
        factor: data?.metadata?.diesel?.factor ?? 0,
        comparison: data?.metadata?.diesel?.comparison ?? null,
      }
      : null,
    hydrogen: data?.metadata?.hydrogen
      ? {
        __typename: "EmissionsReport",
        total: data.metadata.hydrogen.total ?? 0,
        factor: data.metadata.hydrogen.factor ?? 0,
        comparison: data.metadata.hydrogen.comparison ?? null,
      }
      : null,
  }

  // If no breakdown in metadata, use the total value
  if (!data?.metadata?.diesel && !data?.metadata?.hydrogen && data?.value !== null) {
    currentEmissions.diesel = {
      __typename: "EmissionsReport",
      total: data?.value || 0,
      factor: 0,
      comparison: null,
    }
  }

  emissions.push(currentEmissions)

  // Previous day emissions if available
  if (data?.previousValue != null) {
    const previousEmissions: EmissionsType = {
      __typename: "Emissions",
      start: new Date(Date.now() - 86400000).toISOString().split("T")[0],
      diesel: {
        __typename: "EmissionsReport",
        total: data.previousValue || 0,
        factor: 0,
        comparison: null,
      },
      hydrogen: null,
    }
    emissions.unshift(previousEmissions)
  }

  // Determine period from metadata or default to latest
  const period = data?.metadata?.period ?? "today"

  return (
    <Emissions
      period={period}
      emissions={emissions}
      loading={loading}
      error={error}
      title={data?.label}
      isPlaceholder={isPlaceholder}
      compact={compact}
    />
  )
}

export default TotalEmissionsFigure
